let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6ZeYO")).then(() => parcelRequire('4l5Ww'));